import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { LockKey, Envelope } from "@phosphor-icons/react";
import { toast } from "sonner";
import AppLogo from "@/components/AppLogo";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@club.es");
  const [password, setPassword] = useState("admin123");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const result = await login(email, password);
    setLoading(false);
    if (result.ok) {
      toast.success("Bienvenido");
      navigate("/");
    } else {
      toast.error(result.error || "Error de autenticación");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center">
            <AppLogo size={200} rounded={false} />
          </div>
        </div>

        <form
          onSubmit={onSubmit}
          className="bg-white border border-slate-200 p-8 space-y-5 shadow-xl rounded-xl"
        >
          <div>
            <label className="block text-xs tracking-[0.2em] uppercase font-bold text-slate-500 mb-2">Email</label>
            <div className="relative">
              <Envelope size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                data-testid="login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-slate-50 border border-slate-200 pl-10 pr-4 h-12 text-slate-900 focus:border-[#2563EB] focus:ring-2 focus:ring-[#2563EB]/20 focus:bg-white outline-none transition"
                placeholder="admin@club.es"
              />
            </div>
          </div>

          <div>
            <label className="block text-xs tracking-[0.2em] uppercase font-bold text-slate-500 mb-2">Contraseña</label>
            <div className="relative">
              <LockKey size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                data-testid="login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-slate-50 border border-slate-200 pl-10 pr-4 h-12 text-slate-900 focus:border-[#2563EB] focus:ring-2 focus:ring-[#2563EB]/20 focus:bg-white outline-none transition"
                placeholder="••••••••"
              />
            </div>
          </div>

          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full h-12 bg-[#2563EB] hover:bg-[#1d4ed8] text-white font-display font-bold uppercase tracking-widest text-sm transition-all active:scale-[0.98] disabled:opacity-50 rounded-lg shadow-md shadow-blue-500/20"
          >
            {loading ? "Accediendo..." : "Acceder"}
          </button>

          <div className="text-center text-xs text-slate-500 pt-2 border-t border-slate-200">
            Sistema de gestión de socios y accesos
          </div>
        </form>

        <footer className="mt-8 text-center text-xs text-slate-500 space-y-2" data-testid="login-footer">
          <div className="flex items-center justify-center gap-3 flex-wrap">
            <Link data-testid="footer-aviso-legal-link" to="/aviso-legal" className="hover:text-[#2563EB] transition font-medium">Aviso Legal</Link>
            <span className="text-slate-300">·</span>
            <Link data-testid="footer-privacidad-link" to="/privacidad" className="hover:text-[#2563EB] transition font-medium">Privacidad</Link>
            <span className="text-slate-300">·</span>
            <a href="mailto:abraham.herrera@tpvplus.es" className="hover:text-[#2563EB] transition font-medium">Contacto</a>
          </div>
          <div className="text-[11px] text-slate-400">
            © {new Date().getFullYear()} Entradasdeportivas — A.E.I. Marketing y Negocios Tecnológicos, S.L.
          </div>
        </footer>
      </div>
    </div>
  );
}
